export const sortByDeliveryEstimateDays = (deliveryEstimateDaysA, deliveryEstimateDaysB) => (deliveryEstimateDaysA && deliveryEstimateDaysB ? deliveryEstimateDaysA - deliveryEstimateDaysB : 0);
export const sortLeaseOffersByPriceAndDelivery = (leaseOffers, leaseContractType) => {
    const filteredOffers = [...leaseOffers].filter((offer) => {
        const { monthlyPrice, monthlyPriceExVat } = offer || {};
        return leaseContractType === 'personal' ? monthlyPrice : monthlyPriceExVat;
    });
    const sortedOffers = filteredOffers.sort((offerA, offerB) => {
        const { monthlyPrice: monthlyPriceA, monthlyPriceExVat: monthlyPriceExVatA, deliveryEstimateDays: deliveryEstimateDaysA, } = offerA || {};
        const { monthlyPrice: monthlyPriceB, monthlyPriceExVat: monthlyPriceExVatB, deliveryEstimateDays: deliveryEstimateDaysB, } = offerB || {};
        const monthlyPriceAForComparison = leaseContractType === 'personal' ? monthlyPriceA : monthlyPriceExVatA;
        const monthlyPriceBForComparison = leaseContractType === 'personal' ? monthlyPriceB : monthlyPriceExVatB;
        return ((monthlyPriceAForComparison &&
            monthlyPriceBForComparison &&
            monthlyPriceAForComparison - monthlyPriceBForComparison) ||
            sortByDeliveryEstimateDays(deliveryEstimateDaysA, deliveryEstimateDaysB));
    });
    return sortedOffers;
};
export const getCheapestAndFastestDeliveryLeaseOffer = (offers, leaseContractType) => {
    const sortedOffers = sortLeaseOffersByPriceAndDelivery(offers, leaseContractType);
    return sortedOffers.at(0);
};
export const calculateDeposit = (offer, excludeVAT) => {
    const monthlyPrice = (excludeVAT ? offer.monthlyPriceExVat : offer.monthlyPrice) || 0;
    const deposit = offer.depositMonths * monthlyPrice;
    return deposit;
};
export const isSpecialOffer = (offer) => {
    var _a;
    return ((_a = offer === null || offer === void 0 ? void 0 : offer.offerType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'special' || false;
};
/**
 * @deprecated Use getCheapestAndFastestDeliveryLeaseOffer instead
 */
export const findLowestLeaseOffer = getCheapestAndFastestDeliveryLeaseOffer;
export const getDeliveryEstimateBadgeLabel = (deliveryEstimateDays) => {
    if (!deliveryEstimateDays || deliveryEstimateDays > 224) {
        return 'Factory order';
    }
    else if (deliveryEstimateDays <= 21) {
        return '14 - 21 days delivery';
    }
    else {
        const date = new Date();
        date.setDate(date.getDate() + deliveryEstimateDays);
        const dateString = date.toLocaleString('en-GB', {
            month: 'long',
            year: 'numeric',
        });
        return `${dateString} delivery`;
    }
};
